import { ITelemetryItem } from "@microsoft/applicationinsights-web";
import React, { PropsWithChildren, useEffect, useState } from "react";
import { authProvider, getUserPhotoAsync, getUserProfileAsync } from "../../infrastructure/auth";
import { UserContext, UserProfile } from "./";
import { appInsights } from "../../services";
import { LoadingDialog } from "../../components/Loading/LoadingDialog";

export const UserProvider: React.FC<PropsWithChildren<any>> = (props) => {
	const [profile, setProfile] = useState<UserProfile | undefined>(undefined);

	useEffect(() => {
		async function getUserDetailsAsync() {
			try {
				const result = await authProvider.getToken(["User.Read"]);
				if (!result) {
					throw new Error("No authenticated account is available");
				}
				const { accessToken, account } = result;

				const userProfile = await getUserProfileAsync(account, accessToken);
				setProfile({
					photo: await getUserPhotoAsync(accessToken),
					account: account,
					graphProfile: userProfile,
				});
			} catch (error) {
				console.error("Failed to load user profile", error);
			}
		}
		getUserDetailsAsync();
	}, []);

	// Setup application insights based on logged in user details
	useEffect(() => {
		if (profile) {
			appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
				const tags = envelope.tags;
				if (tags && tags["ai.user.authUserId"]) {
					tags["ai.user.id"] = tags["ai.user.authUserId"];
					tags["ai.user.name"] = profile.graphProfile.displayName;
				}
				if (envelope.data) {
					envelope.data.userId = profile.graphProfile.staffId;
					envelope.data.userName = profile.graphProfile.displayName;
					envelope.data.adLocationId = profile.graphProfile.storeNumber;
				}
			});

			// Set authenticated staff id in app insights for additional
			// tracking in AppInsights -> Usage -> Users section with Authenticated users filtered through
			appInsights.setAuthenticatedUserContext(profile.graphProfile.staffId, undefined, true);
		}
	}, [profile]);

	return (
		<>
			<LoadingDialog message="Loading profile" isOpen={profile === undefined} />
			{profile && <UserContext.Provider value={profile}>{props.children}</UserContext.Provider>}
		</>
	);
};
